import {Pressable ,  ImageBackground, Text, View, Button } from "react-native";
import { style_templates } from "../config_variables/styles";
import Icon2 from "react-native-vector-icons/FontAwesome";
// import grouped_stock_data from '../dummy_data/grouped_stock_data'
// import grouped_stock_data from '../dummy_data/stockdata'
// import React, { useState } from 'react'
// import isTest from '../utils/isTest'
// import stockdata_full from '../utils/stockdata'
// import stockdata_min from '../utils/stockdata_min'
// import applyFilters from '../utils/applyFilters'
// import extractDataByFilter from '../utils/extractDataByFilter'
// import initializeFilterSet from '../utils/initializeFilterSet'
// import filter_params from '../utils/filter_params'
// import totalFiltersSelected from '../utils/totalFiltersSelected'
// import mergeFilters from '../utils/mergeFilters'

// import stockdata_btr_only from "../dummy_data/stockdata_btr_only";
import extractDataForConcentrationReport from "../utils/extractDataForConcentrationReport";
import finalizeDataForConcentrationReport from "../utils/finalizeDataForConcentrationReport";
import buildEndpoint from "../utils/buildEndpoint";

export default function HomeScreen({ navigation }) {
  // const [filtercategory, setfiltercategory] =  useState('tranche')
  // const [filteritems, setfilteritems] =  useState({})
  // const [stockdata, setStockdata] = React.useState(stockdata);
  // const [TRANCHES, setTrancheData] = React.useState([]);
  // const stockdata_to_use =  isTest ? stockdata_min : stockdata_full
  // const filter_set = initializeFilterSet(filter_params)
  // const final_filter_set  =  Object.keys(filteritems).length === 0 ? {...filter_set}  : {...filteritems}

  // React.useEffect(() => {
  //     console.log('inside useEffect')
  //     if(TRANCHES.length > 0) {

  //     }
  // }, [TRANCHES]);

  // const changeFilterHandler=  (fc) =>  {
  //     console.log('inside changeFilterHandler')
  //     setfiltercategory(fc)
  //     const filter_set_init = initializeFilterSet(filter_params)
  //     const final_filter_items = mergeFilters(filter_params, filter_set_init, filteritems, filter_set)
  //     setfilteritems(final_filter_items)
  //     const stockdata_after_filters = applyFilters(stockdata_to_use,filter_params,final_filter_set, totalFiltersSelected(final_filter_set))
  //     const initial_card_data = extractDataByFilter(stockdata_after_filters, filter_params[filtercategory],filtercategory)
  //     // console.log('initial_card_data: '+JSON.stringify(initial_card_data))
  //     setTrancheData(initial_card_data)

  function getDataHandler() {
    console.log("inside getDataHandler");
    //     navigation.navigate("Tranches");
//     navigation.navigate("screen1OverallSummary", {
    navigation.navigate("screen2OverallSummary", {
      screenmetrics: {},
    });
    // changeFilterHandler('tranche')
  }

  return (
    <>
      <View style={style_templates.home_screen_container}>
        <ImageBackground
          source={require("../assets/reports3.jpg")}
          resizeMode="stretch"
          imageStyle={style_templates.home_screen_image}
        >

          <View style={style_templates.header_text_container}>
                <Text style={[style_templates.login_page_header_text, {color:"white"}]}>STOCK ALLOCATION MANAGER</Text> 
          </View>
          <View style={style_templates.home_screen_button_group_container}>
            <View style={style_templates.custom_button_wrapper}>
              {/* <Button onPress={getDataHandler} title="START"></Button> */}
              <Pressable onPress={getDataHandler}>
                  <View style={{justifyContent: "center", textAlign: "center", alignContents: "center"}}>
                        <Icon2 name="power-off" size={120} color="#87ceeb" />
                        <Text style= {{color: "white", fontSize: 20, fontFamily: "Arial", fontWeight: "bold"}}>START </Text>
                  </View>
              </Pressable>
            </View>
          </View>
        </ImageBackground>
      </View>
    </>
  );
}
